module.exports = __webpack_public_path__ + "static/kvm_8.37fc153b.jpg";